/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import { useState } from 'preact/hooks';
import { sitePropType } from '../../propTypes';
import NavbarLogo from '../NavbarLogo';
import PrimaryNavigationButtonMenu from '../PrimaryNavigationButtonMenu';
import PrimaryNavigationButtonMenuMobile from '../PrimaryNavigationButtonMenuMobile';
import PrimaryNavigationMenuMobile from '../PrimaryNavigationMenuMobile';
import PrimaryNavigationMenuDesktop from '../PrimaryNavigationMenuDesktop';
import ExploreNavigationButton from '../ExploreNavigationButton';
import ExploreMenu from '../ExploreMenu';
import {
  Backdrop, NavBar, MainContainer, AccessibilityLink,
} from './styles';
import NavbarButton from '../NavbarButton';
import useEscKeyDown from '../../hooks/use-esc-key-down';
import { showSecondaryNav } from '../../utils';

const PrimaryNavigation = ({ data }) => {
  const menusStateClosed = {
    exploreOpen: false,
    primaryDesktopOpen: false,
    primaryMobileOpen: false,
  };
  const [{ exploreOpen, primaryMobileOpen, primaryDesktopOpen }, setMenus] = useState(
    menusStateClosed,
  );

  const showTopRightButton = !data.topRightItem?.children;
  const showTopRightButtonMenu = !!data.topRightItem?.children;
  const showTopRightButtonMenuMobile = !!data.topRightItem || !!data.secondaryMenu?.length;
  const showBackdrop = primaryMobileOpen || exploreOpen || primaryDesktopOpen;
  const showShopButton = !!data?.includeShopButton;
  const showTicketsButton = !!data?.includeTicketsButton;
  const alternateNavbarTheme = !!data?.alternateNavbarTheme;

  const hasSecondaryNav = showSecondaryNav(data);

  const toggleMenu = (event, newMenusState) => {
    // Prevent closeMenus being fired on parent navbar element
    // which would block the menu from opening
    event.stopPropagation();
    setMenus({ ...menusStateClosed, ...newMenusState });
  };

  const closeMenus = () => {
    if (!exploreOpen && !primaryMobileOpen && !primaryDesktopOpen) return;

    setMenus(menusStateClosed);
  };

  const handleExploreClick = e => toggleMenu(e, { exploreOpen: !exploreOpen });
  const handlePrimaryDesktopClick = e => toggleMenu(e, { primaryDesktopOpen: !primaryDesktopOpen });
  const handlePrimaryMobileClick = e => toggleMenu(e, { primaryMobileOpen: !primaryMobileOpen });

  useEscKeyDown(closeMenus);

  return (
    <MainContainer id="nav-master">
      <Backdrop id="ssBackdrop" open={showBackdrop} onClick={closeMenus} />
      <NavBar id="ssNavBar" onClick={closeMenus} alternate={alternateNavbarTheme}>
        <AccessibilityLink href="#main">Skip to content</AccessibilityLink>
        {data.exploreMenuExpandable && (
          <ExploreNavigationButton
            open={exploreOpen}
            onClick={handleExploreClick}
            alternate={alternateNavbarTheme}
          />
        )}
        {data?.logo && <NavbarLogo logo={data.logo} />}
        {showShopButton && <NavbarButton href="https://shop.spyscape.com">SHOP</NavbarButton>}
        {showTopRightButton && (
          <NavbarButton alternate={alternateNavbarTheme} href={data.topRightItem?.link}>
            {data.topRightItem?.title}
          </NavbarButton>
        )}
        {showTopRightButtonMenu && (
          <PrimaryNavigationButtonMenu
            title={data.topRightItem?.title}
            open={primaryDesktopOpen}
            onClick={handlePrimaryDesktopClick}
          />
        )}
        {showTicketsButton && (
          <NavbarButton href="/tickets" primary>
            Tickets
          </NavbarButton>
        )}
        {showTopRightButtonMenuMobile && (
          <PrimaryNavigationButtonMenuMobile
            open={primaryMobileOpen}
            onClick={handlePrimaryMobileClick}
            alternate={alternateNavbarTheme}
          />
        )}
      </NavBar>
      <ExploreMenu
        exploreMenu={data.exploreMenuExpandable}
        open={exploreOpen}
        allowForSecondaryNav={hasSecondaryNav}
      />
      <PrimaryNavigationMenuMobile
        includeTicketsButton={data.includeTicketsButton}
        includeShopButton={data.includeShopButton}
        primaryNavigationButton={data.topRightItem}
        sitePrimaryColor={data.primaryColor}
        items={data.secondaryMenu}
        open={primaryMobileOpen}
        allowForSecondaryNav={hasSecondaryNav}
        alternate={alternateNavbarTheme}
      />
      <PrimaryNavigationMenuDesktop
        itemsExtra={data?.topRightItem?.additionalItems}
        items={data.topRightItem?.children}
        title={data.topRightItem?.title}
        open={primaryDesktopOpen}
        allowForSecondaryNav={hasSecondaryNav}
      />
    </MainContainer>
  );
};

PrimaryNavigation.propTypes = {
  data: sitePropType,
};

PrimaryNavigation.defaultProps = {
  data: null,
};

export default PrimaryNavigation;
